<template>
  <div
    class="w-[376px] h-[464px] mx-[14px] flex-center"
    @mouseenter="upperCover"
    @mouseleave="lowerCover"
  >
    <div
      class="relative w-full h-[424px] flex-col justify-between rounded-[24px] card-shadow select-none cursor-pointer overflow-hidden"
    >
      <NuxtPicture
        :src="
          OSSProcess(
            getCurMediaItemAttribute(
              item.cover.data as MediaDataItem,
              AttrKey.URL
            ),
            'h_212'
          )
        "
        :img-attrs="{
          class: 'block h-full w-full object-cover rounded-t-[24px]',
          alt: getCurMediaItemAttribute(
            item.cover.data as MediaDataItem,
            AttrKey.NAME
          ),
        }"
      />
      <div
        class="absolute-full top-1/2 -left-1 w-[378px] rounded-[16px] card-cover transition-all"
        :style="coverTop"
      >
        <BrandLogo :media="item" :h="50" />
        <div
          v-show="!showCoverContent"
          class="pt-[32px] text-[20px] leading-[32px] font-medium overflow-hidden text-ellipsis break-all line-clamp-2"
        >
          {{ item.title }}
        </div>
        <div
          v-show="showCoverContent"
          class="mt-[30px] mb-[30px] w-full h-[196px] text-[16px] black-text font-400 leading-[28px] overflow-hidden text-ellipsis break-all line-clamp-7"
        >
          {{ item.description }}
        </div>
        <NuxtLink
          v-show="showCoverContent"
          target="_blank"
          class="btn-xmov block w-full rounded-[24px] w-fit no-underline text-[18px] text-center leading-[48px]"
          @click="toDetailPage"
        >
          查看详情
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BrandLogo, { type IBrandItem } from './brand-logo.vue'
import type { MediaDataItem } from '~/api/interface/landing'
import { OSSProcess } from '~/utils/landing'
import { TRACK_EVENT } from '~/utils/track'
import { AttrKey } from '~/constants/landing'

const route = useRoute()

const props = defineProps<{ item: IBrandItem }>()

const coverTop = ref({ top: '200px' })
const showCoverContent = ref(false) // false 则显示 title

function upperCover() {
  coverTop.value = { top: '0' }
  showCoverContent.value = true
}
function lowerCover() {
  coverTop.value = { top: '200px' }
  showCoverContent.value = false
}

function toDetailPage() {
  let trackName = TRACK_EVENT.CLICK_BRAND_CARD

  if (route.name === 'brand') {
    trackName = TRACK_EVENT.CLICK_BRAND_DETAIL_OTHER_CARD
  }

  trackEvent(trackName, {
    card_title: props.item.title,
  })

  location.href = '/brand/' + props.item.id
}
</script>

<style lang="scss" scoped>
.card-shadow {
  box-shadow: 0px 0px 40px 5px rgba(181, 181, 182, 0.4);
}
.card-shadow:hover {
  border: 1px solid transparent;
  box-shadow: 0px 0px 40px 5px rgba(181, 181, 182, 0.4);
  margin-bottom: 10px;
}
.card-cover {
  padding: 32px 32px 40px 32px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0.61) 20%,
    #fff 100%
  );
  border: 1px solid #fff;
  backdrop-filter: blur(14px);
}
</style>
